<style src="./Card.scss" lang="scss" scoped></style>

<template src="./Card.html" />

<script>
export default {
  name: 'Card',
  props: {
    image: String,
    title: String,
    description: String,
  },
};
</script>
